const individualProductResearch = ({ language, isSavedUser }) => {
  return {
    title: "Individual Amazon Product Research",
    subtitle:
      "Order a list of new products for your own business with any specific criteria you have in mind",
    href: "https://sellerhook.com/?utm_source=site&utm_medium=amzscout&utm_campaign=menu",
    isBlank: true,
  };
};

export default individualProductResearch;
